import ListStyle from "../themeList/themeList.module.css"

export default function List({ title, logo }) {
    return (
        <>
            <div className={ListStyle.container}>
                <div className={ListStyle.line_container}>
                    <span className={ListStyle.title}>{title}</span>
                    <span className={ListStyle.line}></span>
                </div>
                <span className={ListStyle.logo}>{logo}</span>
            </div>
        </>
    )
}